<template>
<div>
    <div class="logowrap">
        <img class='logo' src="@/assets/images/jhd-pic.png" />
        <div class='contact-us' >联系我们</div>
    </div>
    <div class="button-dail" @click="makePhonecall">
        <van-icon name="phone-o" /><a href="tel:400-101-5288" onclick="return false">400-101-5288</a>
    </div>
    <div class="button-dail" @click="gotohelpcenter">
        <van-icon name="question-o" /><span>帮助中心</span>
    </div>
    <div class='working-time'>工作时间：周一至周五，上午8:30-12:00 下午1:00-5:30</div>
    <div class='curversion'>当前版本：v4.2.8</div>
</div>
</template>
<script>

export default {
    name: '',
    data () {
        return {
            title: '',
        }
    },
    created() {
      window.makePhonecall = this.makePhonecall;
      this.$service.getStatisCommon("evn_open_page",{});
    },
    methods: {
        makePhonecall(){
          window.android.phone("400-101-5288")
        },
        gotohelpcenter(){
            localStorage.setItem(this.$env+"outPageTitle","帮助中心")
            let pageUrl = 'https://statics.jihuiduo.cn/o2o_help_center/helpCenter.html'
            this.$router.push({path: '/outerPage',query:{pageUrl:pageUrl}})
        },
        tel(){
          return false
        }
    }
}
</script>
<style scoped lang="less">
body{
    background: #fff;
}
.logowrap{
  text-align: center;
}
.logo {
  width:2.8267rem; 
  height:2.5067rem; 
  align-self:center; 
  margin:1.4933rem;
}
.contact-us{
  align-self:center; 
  margin-bottom:0.4rem;
  font-size: 0.4rem;
  color:rgb(153,153,153);
}
.button-dail{
  width: 90%;
  font-family: PingFang-SC-Medium,"Source Han Sans CN Medium","Noto Sans CJK SC Medium";
  font-size: 0.48rem; 
  color:rgb(235,97,18);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f8f8;
  border-radius:0.1333rem;
  margin: 0.1333rem auto;
  height: 1.2267rem;
  a{
    color: rgb(235,97,18);
  }
} 
.button-dail i{
  font-size: 0.56rem; 
} 
.button-dail span,.button-dail a{
  margin-left:0.2667rem;
} 

.button-dail::after{  
  border:0px solid #CC3333;  
} 
.working-time{
  margin-left:0.6667rem; 
  margin-top:0.4rem; 
  margin-bottom:0.1333rem; 
  font-size: 0.3467rem;
  color:rgb(153,153,153);
}
.curversion{
  text-align: center;
  margin-top:0.4rem; 
  margin-bottom:0.1333rem; 
  font-size: 0.32rem;
  color:rgb(153,153,153);
}

button img{
  width: 0.5867rem;
  vertical-align: middle;
  margin-right: 0.32rem;
}
</style>